import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/legal-notice")({
  beforeLoad: () => {
    throw redirect({ to: "/en/legal-notice", statusCode: 301 });
  },
});
